import React, { useState } from 'react';
import styled from 'styled-components';
import Tippy from '@tippyjs/react';

import { CloseIcon } from '@zimpel/common/components/Icon';
import { UnstyledList } from '@zimpel/common/components/Lists';
import type { MessageType } from '@zimpel/common/components/Alert/Alert';
import { backgroundColors, textColors } from '@zimpel/common/components/Alert/Alert';

export const HEADER_NOTIFICATION_WIDTH = '580px';

const StyledTippy = styled(Tippy) <{ $messageType: MessageType }>`
  font-family: var(--font-family-default);
  font-size: var(--font-size-large);
  background-color: ${({ $messageType }) => backgroundColors[$messageType]};
  color: ${({ $messageType }) => textColors[$messageType]};
`;

const Content = styled.div<{ width: string }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: ${({ width }) => `calc(${width} - 40px)`};
  padding: 10px;
`;

type MultilineMessageProps = { message: string[] };
const MultilineMessage: React.FC<MultilineMessageProps> = ({ message }) => (
  <UnstyledList>
    {message.map((line, i) => <li key={i}>{line}</li>)}
  </UnstyledList>
);

type Props = {
  message: string | string[];
  messageType: MessageType;
  width?: string;
  offsetX?: number;
  offsetY?: number;
}
const Notification: React.FC<Props> = ({
  message, messageType, width = '400px', offsetX = 0, offsetY = 0,
}) => {
  const [visible, setVisible] = useState(true);
  return (
    <StyledTippy
      $messageType={messageType}
      maxWidth={width}
      offset={[offsetY, offsetX]}
      content={(
        <Content width={width}>
          {Array.isArray(message) ? <MultilineMessage message={message} /> : <div>{message}</div>}
          <CloseIcon onClick={() => setVisible(false)} leftMargin rightMargin={false} />
        </Content>
      )}
      placement="right"
      visible={visible}
      interactive
      arrow={false}
    >
      <span />
    </StyledTippy>
  );
};

export default Notification;
